import React, { useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtBadge from "../../components/NtBadge";
import colors from "../../config/colors";
import {
  parseDecimalPlaces,
  parseSimpleDisplayDate,
} from "../../common/utils/ControllerUtils";
import NtPinItem from "./NtPinItem";
import NtModal from "../../components/NtModal";
import NtPinManagementUpdateForm from "./NtPinManagementUpdateForm";
import moment from "moment-timezone";
import NtListRow from "../../components/NtListRow";
import { fetchCurrency } from "../utils/CurrencyParser";
import { usePermission } from "../../hooks/usePermission";
import routes from "../../navigation/routes";
import settings from "../../config/settings";

function NtPinManagementItem({ item, type, onUpdate, columns, onReset }) {
  const updateModalRef = useRef();
  const permission = usePermission(
    settings.permissionTypeEdit,
    `${routes.pinmanagement}/${type}`
  );

  const renderUpdateForm = () => {
    return (
      <NtModal ref={updateModalRef}>
        <NtPinManagementUpdateForm
          item={item}
          onCancel={() => {
            updateModalRef.current?.dismiss();
          }}
          onUpdate={() => {
            updateModalRef.current?.dismiss();
            if (onUpdate) {
              onUpdate();
            }
          }}
          onReset={() => {
            updateModalRef.current?.dismiss();
            if (onReset) {
              onReset();
            }
          }}
        />
      </NtModal>
    );
  };

  return (
    <View style={styles.container}>
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(item, column) => {
          if (column == "pin") {
            // this is for pin.....
            return (
              <NtPinItem number={item[column]} enabled={item.active == 1} />
            );
          } else if (column == "credit" || column == "initialbalance") {
            return item.type == "admin"
              ? "N/A"
              : `${fetchCurrency(item.currency)?.symbol}${parseDecimalPlaces(
                  item[column]
                )}`;
          } else if (column == "expirationdate") {
            const expired =
              moment(item[column]) < new Date() && item.expirationdate;
            return (
              <NtText
                style={{ color: expired ? "#e05b59" : colors.lighGray, fontSize: 12 }}
              >
                {item.expirationdate
                  ? parseSimpleDisplayDate(item[column])
                  : "N/A"}
              </NtText>
            );
          } else if (column == "creationdate") {
            return parseSimpleDisplayDate(item[column]);
          } else if (column == "lastuse") {
            return item[column] ? parseSimpleDisplayDate(item[column]) : "";
          } else if (column == "status") {
            const active = item[column] == 1;
            return (
              <NtBadge variant={active ? "green" : "gray"}>
                {active ? "Active" : "Inactive"}
              </NtBadge>
            );
          }
        }}
        onActionPress={
          permission
            ? () => {
                updateModalRef.current?.show();
              }
            : null
        }
      />

      {renderUpdateForm()}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtPinManagementItem;
